<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("template.text23") }}
            </h2>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          justify-center
          align-center
          pt-5
          v-for="(item, i) in Detail"
          :key="i"
        >
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title class="pa-2">
               <div class="pl-3"> {{ item.NameTemplate }}</div> <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="#077893"
                  class="ma-2"
                  @click="Fn_OpenTemplateEmailTest(item)"
                >
                  {{ $t("template.text15") }}</v-btn
                >
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap pa-1 justify-center align-center>
                  <v-flex xs11 lg11>
                    <div v-html="item.SubjectEmail"></div>
                    <br />
                    <br />
                    <div v-html="item.HtmlEmail"></div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogTemplateEmailTest
        :show="DialogTemplateEmailTest"
        :_SubjectEmail="SubjectEmail"
        :_Content="HtmlEmail"
        :_NameTemplate="NameTemplate"
        @closeDialogTemplateEmailTest="DialogTemplateEmailTest = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogTemplateEmailTest from '@/components/dialog/DialogTemplateEmailTest'
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import authorization from '@/functions/authorization.js'
import Swal2 from 'sweetalert2/dist/sweetalert2.js'
import { mapGetters } from 'vuex'
// import 'sweetalert2/src/sweetalert2.scss'
const Toast = Swal2.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})
export default {
  components: { OverlaySearch, DialogTemplateEmailTest },
  data: function () {
    return {
      loadingDownloadData: false,
      DialogTemplateEmailTest: false,
      disabled: false,
      SubjectEmail: '',
      HtmlEmail: '',
      NameTemplate: '',
      Detail: ''
    }
  },
  computed: {
    ...mapGetters(['Business']),
    ...mapGetters(['RoleAccount']),

    _RoleAccount: {
      get () {
        return this.RoleAccount || '-'
      }
    }
  },
  mounted () {
    this.Fn_GetDetailTemplateEmail()
  },
  methods: {
    async Fn_GetDetailTemplateEmail () {
      var payload = {
        BusinessId: this.$cookies.get('BusinessId'),
        TemplateId: this.$route.query.id,
        RoleAccount: this.$cookies.get('RoleAccountId')
      }
      var Headers = {
        AccountId: this.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      this.loadingDownloadData = true
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'config-notify/GetTemplateEmailById',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false

          if (response.data.Status == 'OK') {
            this.Detail = response.data.Message
            if (this.Detail.length == 1) {
              this.Detail = response.data.Message
            } else {
              this.Detail = this.Detail.splice(1)
            }
            this.SubjectEmail = response.data.Message.SubjectEmail
            this.HtmlEmail = response.data.Message.HtmlEmail
            this.NameTemplate = response.data.Message.NameTemplate
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    Fn_BackIndex () {
      this.$router.push('/email-template-index')
    },
    Fn_OpenTemplateEmailTest (val) {
      this.SubjectEmail = val.SubjectEmail
      this.HtmlEmail = val.HtmlEmail
      this.NameTemplate = val.NameTemplate
      this.DialogTemplateEmailTest = true
    }
  }
}
</script>
<style>
td {
  border-style: hidden !important;
}

.space {
  white-space: pre;
}

p {
  margin: 0px;
}

.ql-align-left {
  text-align: left;
}

.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
